var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2090_8464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0564 41.3344H3.94386C1.28986 41.3344 -0.364612 38.4574 0.974552 36.1632L19.5308 4.37204C20.8565 2.10071 24.1412 2.09658 25.4694 4.37204L44.0256 36.1632C45.3636 38.4554 43.7128 41.3344 41.0564 41.3344Z",
    fill: "#EE5253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0503 5.84283L3.49406 37.634C3.29117 37.9817 3.53978 38.416 3.94309 38.416H41.0556C41.4582 38.416 41.708 37.9823 41.5047 37.634L22.9483 5.84283C22.7475 5.49873 22.2523 5.49667 22.0503 5.84283Z",
    fill: "#EE5253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.509 30.7772C23.3666 30.7772 24.0912 31.4909 24.0912 32.3356C24.0912 33.1692 23.3666 33.8734 22.509 33.8734C21.6263 33.8734 20.9082 33.1835 20.9082 32.3356C20.9082 31.4908 21.6413 30.7772 22.509 30.7772ZM22.509 28.3712C21.6212 28.3712 21.0013 27.9412 21.0013 27.3257V18.6334C21.0013 18.1186 21.6071 17.5674 22.509 17.5674C23.322 17.5674 24.0353 18.0656 24.0353 18.6334V27.3257C24.0353 27.9314 23.3934 28.3712 22.509 28.3712Z",
    fill: "#E4EAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74511 36.1631L21.3013 4.37189C21.7709 3.56743 22.5172 3.00763 23.3853 2.78033C21.938 2.40143 20.3473 2.97266 19.5306 4.37189L0.974373 36.1631C-0.363588 38.4551 1.28727 41.3344 3.94369 41.3344H5.71443C3.06025 41.3343 1.40604 38.4571 2.74511 36.1631Z",
    fill: "#EE5253"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_8464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.b1c08038e90e296b5e8d35ca792f5a80.svg";
export { ForwardRef as ReactComponent };